// Wrapping the History API here to push analytics when state is pushed
export default {
  supportsHistory() {
    return window.history && window.history.pushState;
  },
  pushState(data: any, title: string, url: string) {
    if (this.supportsHistory()) {
      window.history.pushState(data, title, url);

      // Trigger Analytics
      if (typeof analytics !== "undefined") {
        analytics.page();
      }
    }
  },
  pushStateNoTracking(data: any, title: string, url: string) {
    if (this.supportsHistory()) {
      window.history.pushState(data, title, url);
    }
  },
}
